import * as React from 'react'
import { FieldContext, useFieldContext } from '../field/field-context'
import { Select } from '../select'
import { useFormFieldContext } from './form-context'

export default function SelectFormField({
  children,
}: {
  children: (
    props: Pick<
      Select.Root.Props<string>,
      'defaultValue' | 'id' | 'name' | 'value' | 'onValueChange'
    > &
      Pick<FieldContext, 'size'>
  ) => React.JSX.Element
}) {
  const field = useFormFieldContext<string>()
  const { size } = useFieldContext()
  return children({
    defaultValue: field.options.defaultValue,
    id: field.name,
    name: field.name,
    size,
    value: field.state.value,
    onValueChange: (value: string) => field.setValue(value),
  })
}
